<template>
  <div class="bg-grey-lighter min-h-screen pb-8">
    <div class="w-full p-8 md:flex md:justify-between items-center">
      <div>
        <Logo></Logo>
      </div>
      <div class="text-navy">
        <button @click="homeButton.cta" class="bg-green hover:opacity-75 text-white py-3 px-4 rounded text-lg mr-8"
                type="button">
          {{ homeButton.label }}
        </button>
        Hi
        <strong>{{ aggregatorName }}</strong>.
        <a @click="logout" class="cursor-pointer hover:opacity-75">Log out</a>
      </div>
    </div>
    <Loading v-if="loading"/>
    <div class="container mx-auto flex flex-start tab">
      <ul class="list-reset flex">
        <li class="mr-1">
          <router-link
            :class="{'no-underline inline-block py-4 px-10 bg-grey-light text-grey-dark': true, 'border-t border-r border-l rounded-t text-green bg-white': activeRoute()}"
            to="/aggregator/brokers">Brokers
          </router-link>
        </li>
        <li v-for="broker in brokerTabs" :key="broker.id" class="mr-1 relative">
          <router-link
            :class="{'no-underline inline-block py-4 px-10 bg-grey-light text-grey-dark': true, 'border-t border-r border-l rounded-t text-green bg-white': activeRoute(broker.id)}"
            :to="`/aggregator/broker/${broker.id}`">{{ broker.name }}
          </router-link>
          <button @click="removeBroker(broker)"
                  class="absolute cursor-pointer flex leading-none items-center justify-center -mt-2 -mr-2 pin-t pin-r text-white bg-green h-4 w-4 rounded-full">
            x
          </button>
        </li>
      </ul>
    </div>
    <router-view/>
    <BrokerFooter/>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import Logo from '@/assets/Logo';
import {mapMutations, mapState} from 'vuex';
import BrokerFooter from '@/components/BrokerFooter';

export default {
  name: 'AggregatorIndex',
  components: {Loading, Logo, BrokerFooter},
  metaInfo: {
    title: 'Aggregator',
  },
  data() {
    return {
      loading: false,
      homeButton: {
        cta: this.fetchBrokerId,
        label: 'Accredit a new broker',
      },
    };
  },
  created() {
    this.$root.$on('createNewBroker', this.fetchBrokerId);

    if (this.$route.name === 'AggregatorIndex') {
      this.$root.$emit('createNewBroker');
    }
  },
  watch: {
    $route(route) {
      if (route.name === 'AggregatorBrokerAppList' || route.name === 'AggregatorBrokerListPage') {
        this.homeButton = {
          cta: this.fetchBrokerId,
          label: 'Accredit a new broker',
        }
      } else {
        this.homeButton = {
          cta: this.goHome,
          label: 'Home',
        }
      }
    },
  },
  computed: {
    ...mapState({
      brokerTabs: ({brokers}) => brokers.brokerTabs,
    }),
    aggregatorName() {
      return this.$auth.getTokenData().name;
    },
    activeRoute() {
      return (currentId) => currentId === this.$route.params.id;
    },
  },
  methods: {
    ...mapMutations({
      toggleBroker: 'brokers/toggleBroker',
    }),
    removeBroker({name, id}) {
      this.toggleBroker({name, id})
      this.goHome()
    },
    goHome() {
      this.$router.push({name: 'AggregatorBrokerListPage'})
    },
    async fetchBrokerId() {
      this.loading = true;
      try {
        const data = await this.$http.get('aggregator/request-uid');
        const {id} = data.body;
        this.loading = false;
        return this.$router.push(`/aggregator/${id}`);
      } catch (e) {
        this.$toasted.error(`Error: ${(e.body && e.body.error) || e.message || 'Could not fetch broker'}`)
      }
    },
    logout() {
      this.$auth.destroyToken();
      this.$router.push('/aggregator');
    },
  },
};
</script>
<style scoped>
.tab {
  min-width: 1132px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Aggregator/AggregatorIndex.vue